import React, { FC } from 'react';
import styles from './index.module.scss';
import TendersBoardList from '../TendersPage/TendersBoard/TendersBoardList';
import { useParams, Navigate } from 'react-router-dom';
import { PageHeading, Skeleton, Section, InfoIcon, EmptyFilter } from 'src/common';
import { useTranslation } from 'react-i18next';
import { useBuyerById } from 'src/models/organisations/hooks';
import { useFeatureFlag, FeatureFlag } from 'src/helpers/featureFlag';
import { Paths } from '../paths';
import { faClockEight, faClockRotateLeft, faUsdCircle } from '@fortawesome/pro-light-svg-icons';
import { Competitors } from 'src/shared';
import BuyerTenderPreview from './Preview';
import { ApiTendersProvider } from 'src/models/procurements/Tenders/providers';

const BF_SMART_LINK = `https://smart.byggfakta.se/ca-redirect?orgNumber=`;
export const BuyerPage: FC = () => {
  const { t } = useTranslation();
  const { orgId } = useParams<{ orgId: string }>();
  const { data: buyer, loading } = useBuyerById(orgId);
  const smartLink = `${BF_SMART_LINK}${orgId}`;
  const isBuyerPageAvailable = useFeatureFlag(FeatureFlag.AnalyticsOrganisationProfiles);
  const isSmartLinkAvailable = useFeatureFlag(FeatureFlag.ByggfaktaSmartLink);
  const isCompetitorsFeature = useFeatureFlag(FeatureFlag.Users_Competitors);

  return isBuyerPageAvailable ? (
    <>
      {loading ? (
        <Skeleton active loading />
      ) : buyer ? (
        <>
          {buyer.organisationName && (
            <PageHeading
              title={buyer.organisationName}
              actions={
                isSmartLinkAvailable && (
                  <a className={styles.smartLink} rel={'noopener noreferrer'} target={'_blank'} href={smartLink}>
                    <span>{`Byggfakta Smart`}</span>
                  </a>
                )
              }
            />
          )}
          {!!isCompetitorsFeature && (
            <Section
              title={t('Competitors.competitors')}
              actions={<InfoIcon desc={t('Competitors.competitorsDesc')} />}
              icon={{ defaultIcon: faUsdCircle, color: '#FA541C' }}
            >
              <Competitors orgId={orgId} />
            </Section>
          )}
          <Section title={t('BuyerProfiles.activeTenders')} icon={{ defaultIcon: faClockEight, color: `#52C41A` }}>
            <ApiTendersProvider type={'BuyerRecent'}>
              <TendersBoardList className={styles.tenders} loadEvent={'click'} loadType={'link'} />
              <BuyerTenderPreview />
            </ApiTendersProvider>
          </Section>
          <Section
            title={t('BuyerProfiles.previousTenders')}
            icon={{ defaultIcon: faClockRotateLeft, color: `#F5222D` }}
          >
            <ApiTendersProvider type={'BuyerExpired'}>
              <TendersBoardList className={styles.tenders} loadEvent={'click'} loadType={'link'} />
              <BuyerTenderPreview />
            </ApiTendersProvider>
          </Section>
        </>
      ) : (
        <EmptyFilter title={t('BuyerProfiles.noBuyer.title')} desc={t('BuyerProfiles.noBuyer.desc')} />
      )}
    </>
  ) : (
    <Navigate to={Paths.HOME_PATH} />
  );
};

export default BuyerPage;
